var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('br'),_c('InfoCard',{attrs:{"msg":""}},[[_c('SocialMediaModule')]],2),_c('YoutubeModule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }